import { createConsola } from 'consola'

export const useLogger = (context: string = 'default') => {
  const { public: { logLevel = 1 } } = useRuntimeConfig()

  const { info, error, warn, log, trace, debug, verbose } = createConsola({
    level: logLevel,
    formatOptions: {
      colors: false,
      compact: true,
      date: true,
    },
  }).withTag(context)

  return {
    info,
    error,
    warn,
    log,
    trace,
    debug,
    verbose,
  }
}
